<template>

      <v-card
        class="mx-auto"
        max-width="1000"
        min-width="300"
      >
        <v-toolbar class="pencil"  :color="ToolColor" dark @click="Loadin();Hide = !Hide">
          <v-toolbar-title>{{ Headline }}</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="Hide == false" color="orange ligthen-1" >arrow_downward</v-icon>
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        </v-toolbar>
        
  <v-expand-transition >
        <div  v-if="Hide">
           <newExtra  :schoolId="schoolId" :classes="classesnameandId" :id="id"  v-model="New"   />
   
  <div v-if="extras!=0">
  <v-flex justify="center">
           <NewClassExtra   :schoolId="schoolId" :classen="ClassnameandId.class" :oldExtra="oldExtra" :classId="ClassnameandId.id"  v-model="Newclass" />
    <newExtra  :schoolId="schoolId" :classes="classesnameandId" :Oldclass="accessItem" :id="id"  v-model="dialogAccess"   />
    <v-flex v-if="Anpassning!=null &&  InfoClass==false">
      <Moreinfo :schoolId="schoolId" :role="role" :Info="Anpassning" :id="id"  v-model="Info" :teachernameandId="teachernameandId" :adaptations="unvail(Anpassning.adaptations).map(a => a.value)" />
   
    </v-flex>
        <v-flex v-if="AnpassningClass!=null &&  Info==false">
       <Moreinfo :schoolId="schoolId" :role="role" :Info="AnpassningClass" :id="id"  v-model="InfoClass" :teachernameandId="teachernameandId" :adaptations="AnpassningClass.ClassAdaptations" />
   
    </v-flex>
<RemoveWindow 
        v-model="dialogDelete" Type="Extra"  :removeItem="removeItem"  Headline="Ta bort Extraanpassning för" WarningText="Är extraanpassningen inte aktuell längre? Hurra för både eleven och dig, bra jobbat!"    />
       </v-flex>

                   <v-text-field
          v-model="search"
          label="Sök efter elev"
          class="mx-4"
          clearable
        ></v-text-field>
  <v-btn @click="New=true" dark color="green ligthen-1">
    Lägg till extraanpassning!
  </v-btn>
{{classget}}
    <v-flex v-for="clas, index in classinfo" :key="(clas.class+index)"> 
     <v-toolbar  :color="'light-green lighten-'+(index+1)" dark @click="change(index) ">
          <v-toolbar-title>{{clas.class}}</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="clas.Hide == false" color="orange ligthen-1" >arrow_downward</v-icon>
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        </v-toolbar>
<div  v-if="clas.Hide">
         <v-flex xs12>
                  <div class="headline">Klassanpassningar:</div>

            <v-card color="blue-grey darken-2" class="ma-2 white--text">
              <v-card-title primary-title>
                <div>
                  <!-- Classlevel -->
             <div v-for="category,index in extras.filter(e=> e.hasOwnProperty('classLevel')).filter(item => item.class==clas.id)"  :key="(category+index)">
                  
                    <v-chip 
                    v-for="(text,i2) in category.ClassAdaptations" :key="text+index"
      class="ma-2"
      :color="colors[index]"
      text-color="white"
      @click="AnpassningClass=category;InfoClass=true;"
    >
     {{text}}


                      <v-chip v-if="!category.teacherIds[i2].split(',')[0]==''"
                       
      class="ma-2"
      :color="colors[index+1]"
      text-color="white"
      
       @mouseover=" showTipSnackbar(category.teacherIds[i2].split(',').length+' lärare använder denna anpassning för '+category.name)"
    >
     {{

     category.teacherIds[i2].split(',').length
          }}  <v-icon right>school</v-icon>
    </v-chip>
    </v-chip>
               </div>

                </div>
              </v-card-title>
              <v-card-actions>
                <v-btn flat dark @click="ClassnameandId=clas;oldExtra=extras.find(e=> e.hasOwnProperty('classLevel') && e.class==clas.id );Newclass=true">{{true==extras.find(e=> e.hasOwnProperty('classLevel' && e.class==clas.id ))?'Lägg till':'Ändra'}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <!-- ELEVNIVÅ -->
          <div  v-if="extras.filter(e=> !e.hasOwnProperty('classLevel')).filter(item => item.class==clas.id).length!=0">
                  <div class="headline">Elevanpassningar:</div>
   <v-data-table 
      :headers="headers"
      :items="extras.filter(e=> !e.hasOwnProperty('classLevel')).filter(item => item.class==clas.id) "
      item-key="name"
      sort-by="name"
      class="elevation-1"      
      :pagination.sync="pagination"
     :search="search"
      show-group-by
    > 
    <!--  -->
      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.name }}</td>
  
        <td class="text-xs-right">          
          
             <div v-for="category,index in unvail(props.item.adaptations)"  :key="(category+index)">
                  
                    <v-chip
                    v-for="(text,i2) in category.value" :key="text+index"
      class="ma-2"
      :color="colors[index]"
      text-color="white"
      @click="Anpassning=props.item;Info=true;"
    >
     {{text}}

                      <v-chip v-if="!props.item.teacherIds[category.startIndex+i2].split(',')[0]==''"
                       
      class="ma-2"
      :color="colors[index+1]"
      text-color="white"
      
       @mouseover=" showTipSnackbar(props.item.teacherIds[category.startIndex+i2].split(',').length+' lärare använder denna anpassning för '+props.item.name)"
    >
     {{
     props.item.teacherIds[category.startIndex+i2].split(',').length
          }}  <v-icon right>school</v-icon>
    </v-chip>
    </v-chip>
               </div>
          
        </td>
              
     <td class="text-xs-right">
        {{  props.item.hasOwnProperty('uploadDate') ?    locfun.getDate(
                props.item.uploadDate
            ): 'Ingen data att visa' }} 
          </td>
         <td  class="text-xs-right">
          <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              accessItem=props.item; dialogAccess = true;
            "
            color="green ligthen-1"
          >
            <v-icon dark> upgrade </v-icon>
          </v-btn>
        </td>
        <td class="text-xs-right" >
  <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              removeItem = props.item;
              dialogDelete = true;
            "
            color="red ligthen-1"
          >
            <v-icon dark> clear </v-icon>
          </v-btn>
        </td> 

      </template>
            <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
         Det finns inget resultat för din sökning på "{{ search }}". 
        </v-alert>
      </template>
    </v-data-table>
          </div>
        </div>
    </v-flex>
             <div class="text-xs-center pt-2">
      <v-btn color="light-blue darken-1" dark @click="toggleOrder">Ändra sorteringsordning</v-btn>
      <v-btn color="light-blue darken-1" dark @click="nextSort">Sortera på nästa kolumn</v-btn>
    </div>
  </div>
   <div v-else  class="bellowPen" :class="ToolColor+ ' lighten-2 text-center'">  
    <span class="tt" color="white">Det finns inga Extraanpassningar inlagda än.</span>
      <v-btn @click="New=true" dark color="green ligthen-1">
    Lägg till extraanpassning
  </v-btn>
    </div>
        </div>
  </v-expand-transition>
      </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import fun from "../functions";
// import NewAP from "./NewAP";
import RemoveWindow from "../assets/RemoveWindow";
import NewExtra from './newExtra.vue';
import Moreinfo from './moreinfo.vue';
import NewClassExtra from './newClassExtra.vue';
export default {
  name: "extra",
  components: {
    
    RemoveWindow,
    NewExtra,
    Moreinfo,
    NewClassExtra
  },
  props: {
    // content: Array,
    Headline: String,
    ToolColor: String,
    schoolId: String,
    role: String,
    id: String,
    
  },

  watch: {

  },
  created() {
    this.locfun = new fun();
//   }
  },
  computed: {
    classget(){
      if(this.classesFetched==false)
        initClasses(this.schoolId)

      if (this.start==false && this.classesFetched==true) {
      let info=[]
      for (let j = 0; j < this.classesnameandId.length; j++)
      for (let i = 0; i < this.classesnameandId[j].length; i+=2) {
        info.push({class: this.classesnameandId[j][i], id: this.classesnameandId[j][i+1], Hide:false})
      }
      this.classinfo= info
      this.start=true;
      }
      // return info
    },
    ...mapGetters("extra", ["extras","extrasFetched"]),
    ...mapGetters("teachers", ["teachernameandId"]),
    ...mapGetters("ehtmembers", ["membernameandId",]),
    ...mapGetters("classesAP", ["classesnameandId",'classes','classesFetched']),
  },
  methods: {
Loadin()
{
if (this.extrasFetched==false) {
  
if (this.role=="teacher" && this.classesnameandId.length!=0) 
  this.initExtra({schoolId:this.schoolId, classes: this.classesnameandId.map(x => x[1])});
else if (this.role=="eht") 
  this.initExtraEHT(this.schoolId);
  
      //console.log("Fetched")
}

},


change(index){
  this.classinfo[index].Hide = !this.classinfo[index].Hide
  
},
counter(category,number)
{
return this.Startvalue[category]+number

},
unvail(letters)
{
let split=  letters.split(",");
let bokstäver= "abcdefghijklmno"
let clearText= [{value:[]},{value:[]},{value:[]},{value:[]},{value:[]},{value:[]},{value:[]}]
for (let i = 0; i < split.length; i++) {
 for (let j = 0; j < bokstäver.length; j++) {
   if (bokstäver[j]==split[i][0]) {
     clearText[j].value.push(this.underkategorier[j].choices[split[i][1]])
   }
   
 }
  
}
// this.Startvalue=[]
//  this.Startvalue.push(0)
 
clearText[0].startIndex =0
for (let i = 1; i < clearText.length; i++) {
  if (clearText[i-1].value!=null) {
  clearText[i].startIndex= clearText[i-1].value.length;
    
  }
}

return clearText
},
    ...mapActions("extra", ["initExtra",'initExtraEHT']),
    ...mapActions("classesAP", ['initClasses']),
    ...mapActions(['showTipSnackbar','showSuccessSnackbar']),
    toggleOrder () {
        this.pagination.descending = !this.pagination.descending
      },
      nextSort () {
        let index = this.headers.findIndex(h => h.value === this.pagination.sortBy)
        index = (index + 1) % this.headers.length
        index = index === 0 ? index + 1 : index
        this.pagination.sortBy = this.headers[index].value
      },




    ...mapActions(["showTipSnackbar"]),
  },
  data() {
    return {
      
      search: '',
            pagination: {
          sortBy: 'steps[0].starttime'
        },
      New:false,
      Newclass:false, 
      oldExtra: null,
      ClassnameandId: {},
      Startvalue: [],//Används i counter för att få startvärdet
      removeItem: { name: "temp", id: "temp" },
      accessItem: null,
      dialogDelete: false,
      dialogAccess: false,
      start:false,
      Info:false,
      InfoClass:false,
      Anpassning: null,
      AnpassningClass: null,
      classinfo: [],
      dis: {},
      dialog: false,
      dialogClass: false,
      Class: null,
      Choosen: null,
      Hide: false,
      colors:["orange","green","light-blue","purple","pink","blue"],
       underkategorier: [
        {
          name: "Kommunikation/Information",
          hint: "Eleven behöver anpassningar på grund av svårigheter med kommunikation/information",
          choices: [
            "Tydlig skriftlig information",
            "Orienteringskarta över skolan",
            "Skyltar som visar vad som finns var",
            "Fotografier och skyltar på respektive dörr i skolan som visar vad och vem som finns där",
            "Anpassad kommunikation (färre ord, begränsad meningslängd)",
            "Sammanhangsförklaringar (förklara det underförstådda, hur sammanhangskedjan hänger ihop och ge svar på de frågor eleven själv har svårt att ställa)",
            "Hjälpmedel för att be om hjälp (t.ex. ett ”behöver hjälp”-kort på bänken)",
            "Visuellt samtalsstöd (sociala berättelser, ritprat, dataprat, samtalsmatta(för mer info besök www.dart-gbg.org/samtalsmatta) )",
            "Stresstermometer (kunna visa hur stark t .ex. stressen är)",
            "Sociala manus",
            "Smartboard",
            "Smartphone",
          ],
        },
        {
          name: "Planering/Organisation",
          hint: "Eleven behöver anpassningar på grund av svårigheter att planera och organisera",
          choices: ["Att-göra-listor","Hur-göra-listor","Visuella arbetsordningar och planeringslinjer, tidslinjer"
          ,"Visualisera händelser − sammanhangskedjor","Nedbrutna arbetsuppgifter i små tydliga steg","Färgkodning av schema och böcker",
          "Stöd att komma i gång","Stöd att avsluta","Påminnelselistor – auditivt minnesstöd"],
        },
                {
          name: "Sinnesintryck",
          hint: "Eleven behöver anpassningar på grund av annorlunda perception (”intrycksallergi”)",
          choices: ["Krok/skåp längst ut (inte behöva trängas med andra)"," Sitta längst bak/längst fram/närmast dörren i klassrummet","Få använda hörselkåpor, mp3, iPod, Audio Comfort-hjälpmedel eller ER-hörselskydd i klassrummet"
          ,"Få använda keps/solglasögon","Skärmvägg","Stol med armstöd (svårt hålla kroppen upprätt längre stunder)",
          "Bolldyna/kilkudde","Särskild kost på grund av annorlunda perception."," Äta i enskilt rum/lugnare plats i matsalen",
          "Tillåtelse att vara inne på raster","Särskilda papper eller pennor"," Skriva med dator i stället för med penna",
          "Möbeltassar på stolar och bänkar (minimera stolskrap)","Sitta långt ifrån fläktsystem/ventilationstrumma","Anpassningar i omklädningsrum och gymnastiksal.",],
                  },
                {
          name: "Uppmärksamhet",
          hint: "Eleven behöver anpassningar på grund av bristande uppmärksamhetsförmåga",
          choices: ["Placering i klassrummet utan distraherande störningsmoment (t.ex. ej vid fönster)","Skärmvägg","Läslinjal","Uppdelade arbetsuppgifter i delmoment","Uppgifter på papper i stället för tjocka böcker","Skriftliga instruktioner på tavla samt bänk"
          ,"Anpassade arbetspass efter hur länge eleven klarar att hålla kvar uppmärksamheten","Tätare pauser","Minnesstöd",
          "Talförstärkare","Övergångsuppgifter","Förståelse för att eleven kan behöva resa på sig och röra sig eller sitta och pillra med något samtidigt som han/hon lyssnar"
          ],  },
                          {
          name: "Impulsivitet/aktivitet",
          hint: "Eleven behöver anpassningar på grund av bristande impulskontroll",
          choices: ["Minimera störande intryck i närheten", "Överenskommelser om att få gå ifrån lektion vid stress",
 "Anpassningar i situationer där man behöver vänta (t.ex. kö till matsal)"
          ],  },
                                    {
          name: "Tidsuppfattning",
          hint: "Eleven behöver anpassningar på grund av bristande tidsuppfattning",
          choices: ["Tidshjälpmedel (t.ex. Time Timer, timstock, timer, timglas)", "Rastschema (uträknat efter vad man hinner under en kvartsrast eller lunchrast)",
          "Överskådliga kalendrar", "Överskådliga tidslinjer"
          ],  },
                                              {
          name: "Flexibilitet",
          hint: "Eleven behöver anpassningar på grund av svårigheter med föreställningsförmåga och/eller av bristande flexibilitet",
          choices: ["Schema som talar om vad som ska hända, när, hur länge, med vem och vad som händer sedan", "Rastschema med förslag på aktiviteter",
          "Stöd av plus- och minuslistor i uppgifter där man ska reflektera eller analysera","Anpassade uppgifter där det krävs föreställningsförmåga att exempelvis kunna föreställa sig hur det är att bo i andra länder, hur det var förr i tiden, hur något kan bli i framtiden",
          "Övergångsuppgifter","Förbereda för att det snart är dags att börja med något respektive att avsluta, t.ex. med hjälp av ett tidshjälpmedel",
          "Undvika förändringar, förberedelser inför förändringar","Tydliga regler och uppdragsbeskrivningar","Ett mjukt och följsamt bemötande av omgivningen",
          "Planering som inbegriper en plan B om en aktivitet inte går att genomföra"
          ],  },
      ],


      headers: [
        {
          text: "Elevnamn",
          align: "start",
          value: "name"
        },
        // { text: "Klass", value: "class", align: "right" },
        { text: "Anpassning", value: "course", align: "right" , access:"eht"},
        { text: "Uppdaterad", value: "cause", align: "right" },
        { text: "Ändra", value: "ändra", align: "right" , access:"eht" },
        { text: "Ta bort", value: "tabort", align: "right" , access:"eht"},
      ],
    };
  },
};
</script>

<style >
.button {
  font-size: 30px;
}

</style>